const EXEMPT_PATHS = [
  "/embed",
  "/reset-password",
  "/auth-group",
  "/viewcontent",
  "/chatembed",
  "/group/about",
  "/lead",
  "/share",
  "/dashboard"
];

export function getRedirectPath(pathname, dashboardOnly) {
  const currentPath = pathname;
  const isOnExemptPath = EXEMPT_PATHS.some(path => currentPath.includes(path));

  if (dashboardOnly && !isOnExemptPath) return "/dashboard";
  else return null;
}
